import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import LoginCarousel from "./LoginCarousel";
import { apiKey } from "../../config/config";
import axios from "axios";
import { toast } from "react-toastify";

// Set Axios to include credentials with requests
// axios.defaults.withCredentials = true;

function Login() {
  const navigate = useNavigate();
  const [credentials, setCredentials] = useState({
    email: "",
    password: "",
  });
  const [loading, setLoading] = useState(false);

  const carouselData = [
    {
      img: "assets/admin/1.svg",
      para: "Online ordering allow customers order food through your restaurant website",
      btn: "Learn More",
    },
    {
      img: "assets/admin/2.svg",
      para: "Delivering powerful user retention with food delivery loyalty and discount management",
      btn: "Learn More",
    },
    {
      img: "assets/admin/3.svg",
      para: " Collect orders and payments online for your food store, grocery store, or market Learn more",
      btn: "Learn More",
    },
  ];

  const handleInput = (e) => {
    setCredentials((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleLogin = (e) => {
    e.preventDefault();
    setLoading(true);
    //   .get(apiKey + "/sanctum/csrf-cookie")
    //   .then((response) => {
    //     // Extract the CSRF token from cookies
    //     const csrfToken = document.cookie
    //       .split("; ")
    //       .find((row) => row.startsWith("XSRF-TOKEN="))
    //       .split("=")[1];

    //     // After getting CSRF token, make the login request
    //     return axios.post(apiKey + "/api/rms/admin/login", credentials, {
    //       
    //       headers: {
    //         "Content-Type": "application/json",
            
    //       },
    //     });
    //   })
    //   .then((res) => {
    //     localStorage.setItem("rms-admin", JSON.stringify(res.data.data));
    //     toast.success(res.data.message, {
    //       position: "bottom-right",
    //       autoClose: 5000,
    //       hideProgressBar: false,
    //       closeOnClick: true,
    //       pauseOnHover: true,
    //       draggable: true,
    //       progress: undefined,
    //       theme: "colored",
    //     });
    //     // Navigate to another page or do something after successful login
    //     navigate("/POS/main");
    //   })
    //   .catch((err) => {
    //     console.error(err);
    //     toast.error(err.response.data.message, {
    //       position: "bottom-right",
    //       autoClose: 5000,
    //       hideProgressBar: false,
    //       closeOnClick: true,
    //       pauseOnHover: true,
    //       draggable: true,
    //       progress: undefined,
    //       theme: "colored",
    //     });
    //   })
    //   .finally(() => setLoading(false));

      axios.post(apiKey + "/api/rms/admin/login", credentials, {
        
        headers: {
          "Content-Type": "application/json",
          
        },
      }).then((res) => {
        localStorage.setItem("rms-admin", JSON.stringify(res.data.data));
        toast.success(res.data.message, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        // Navigate to another page or do something after successful login
        navigate("/POS/main");
      })
      .catch((err) => {
        console.error(err);
        toast.error(err.response.data.message, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (localStorage.getItem("rms-admin")) {
      navigate("/POS/main");
    }
  }, [navigate]);

  return (
    <>
      <main
        className="w-full min-h-screen grid place-items-center py-4"
        style={{
          backgroundImage: "url('assets/admin/bg.svg')",
        }}
      >
        <div className="bg-white max-w-[850px] w-[90%] flex gap-6 p-6">
          <div className="w-full md:w-1/2">
            <div>
              <img
                className="w-40"
                src="assets/logo/imdady_logo.png"
                alt=""
              />
            </div>
            <div className="px-4">
              <h3 className="text-[#61357e] font-semibold text-2xl font-[popins]">
                Welcome to RMS
              </h3>
              <p className="text-[#61357e] text-sm">
                Please sign-in to your account and start the adventure
              </p>
              <form onSubmit={handleLogin} action="">
                <input
                  className="w-full px-8 py-2 bg-[#F6F7FC] border border-[#61357e] shadow-md my-2 rounded-md"
                  type="text"
                  placeholder="Email Address"
                  name="email"
                  onChange={handleInput}
                />
                <input
                  className="w-full px-8 py-2 bg-[#F6F7FC] border border-[#61357e] shadow-md my-2 rounded-md"
                  type="password"
                  placeholder="Password"
                  name="password"
                  onChange={handleInput}
                />
                <button
                  type="sunbit"
                  className="w-full rounded-md bg-[#61357e] text-white text-center py-2 my-2 relative"
                >
                  {loading && (
                    <span className="absolute top-0 left-0 w-full h-full py-1 px-3 bg-black bg-opacity-50">
                      <img
                        className="w-4 mx-auto"
                        src="https://i.gifer.com/ZKZx.gif"
                        alt=""
                      />
                    </span>
                  )}
                  Login
                </button>
                <div className="text-center text-[#626262] my-2">
                  Forgot Password?
                </div>
                <div className="my-4">
                  <hr />
                </div>
                <div className="flex gap-x-2 justify-center items-center">
                  <img
                    src="assets/admin/fb.png"
                    alt=""
                  />
                  <img
                    src="assets/admin/li.png"
                    alt=""
                  />
                  <img
                    src="assets/admin/tw.png"
                    alt=""
                  />
                  <img
                    src="assets/admin/in.png"
                    alt=""
                  />
                </div>
              </form>
            </div>
          </div>
          <div className="w-1/2 hidden md:block">
            <LoginCarousel carouselItems={carouselData} />
          </div>
        </div>
      </main>
    </>
  );
}

export default Login;
